<mat-card class="order-list-container">
    <mat-card-title>Shipping</mat-card-title>

    <mat-paginator [length]="totalNumberOfOrders" [pageIndex]="page-1" [pageSize]="limit"
        [pageSizeOptions]="[10, 15, 20]" showFirstLastButtons (page)="onPageChange($event)"
        aria-label="Select page of orders">
    </mat-paginator>

    <div class="py-2">
        <mat-divider></mat-divider>
    </div>
    
    <table mat-table [dataSource]="ordersDataSource" class="order-list">

        <ng-container matColumnDef="orderNumber">
            <th mat-header-cell *matHeaderCellDef> # </th>
            <td mat-cell *matCellDef="let order"> {{order.id}} </td>
        </ng-container>

        <ng-container matColumnDef="owner">
            <th mat-header-cell *matHeaderCellDef> Owner </th>
            <td mat-cell *matCellDef="let order"> {{getOwnerName(order)}} </td>
        </ng-container>

        <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef> Status </th>
            <td mat-cell *matCellDef="let order"> {{order.status.status}} </td>
        </ng-container>

        <ng-container matColumnDef="sage">
            <th mat-header-cell *matHeaderCellDef> Sage </th>
            <td mat-cell *matCellDef="let order"> {{getSageSyncLabel(order)}} </td>
        </ng-container>

        <ng-container matColumnDef="created_at"> 
            
            <th mat-header-cell *matHeaderCellDef>Created
            </th>
            <td mat-cell *matCellDef="let order"> {{getCreationTime(order)}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row (click)="openOrder(row.id)" *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

</mat-card>